export const LEFT = 'left'
export const RIGHT = 'right'
export const TOP = 'top'
export const BOTTOM = 'bottom'
export const DEFAULT_COORDS = { x: -1000, y: -1000 }
export const TOOLTIP_SAFE_SPACE = 10
